(function($) {
  'use strict';

    //NavBar Logo Color
    var navLogo = $(".navbar-brand").attr("id")

    //check window size
    $(document).ready(function() {
        // run test on initial page load
        checkSize();
        // run test on resize of the window
        $(window).resize(checkSize);
    });

    //Check css rule
    function checkSize() {
        //Check if logo is white
        if (navLogo == "nav-logo-color-white") {
            $('.navbar-brand').addClass('DYL-white-logo');

            //Nav Button
            if($(".btn-responsive-color").css("text-align") == "center"){
                $('.btn-responsive-color').removeClass('btn-blue-ribbon');
                $('.btn-responsive-color').addClass('btn-white-primary');
            }
           
            if($(".btn-responsive-color").css("text-align") == "left"){
                $('.btn-responsive-color').removeClass('btn-white-primary');
                $('.btn-responsive-color').addClass('btn-blue-ribbon');
            }
        }

        // Check if logo is blue to white
        if (navLogo == "nav-logo-color-blue-white") {
            //Nav logo
            if ($(".DYL-logo").css("z-index") == "1000") {
                $('.navbar-brand').removeClass('DYL-blue-logo');
                $('.navbar-brand').addClass('DYL-white-logo');
            }
            if ($(".DYL-logo").css("z-index") == "999") {
                $('.navbar-brand').removeClass('DYL-white-logo');
                $('.navbar-brand').addClass('DYL-blue-logo');
            }
            //Nav Button
            if($(".btn-responsive-color").css("text-align") == "center"){
                $('.btn-responsive-color').removeClass('btn-blue-ribbon');
                $('.btn-responsive-color').addClass('btn-white-primary');
            }
           
            if($(".btn-responsive-color").css("text-align") == "left"){
                $('.btn-responsive-color').removeClass('btn-white-primary');
                $('.btn-responsive-color').addClass('btn-blue-ribbon');
            }  
        }

        //Check if logo is logo white, button blue, hold when responsive
        if (navLogo == "nav-logo-color-white-blue-hold") {
            //Nav logo
            if ($(".DYL-logo").css("z-index") == "1000") {
                $('.navbar-brand').removeClass('DYL-blue-logo');
                $('.navbar-brand').addClass('DYL-white-logo');
            }
            if ($(".DYL-logo").css("z-index") == "999") {
                $('.navbar-brand').removeClass('DYL-blue-logo');
                $('.navbar-brand').addClass('DYL-white-logo');
            }
        }
    }

    // Activate Tooltips & Popovers
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();

        // Dismiss Popovers on next click
        $('.popover-dismiss').popover({
            trigger: 'focus'
        })
    });

    // Bootstrap Fixed Header
    $(function () {
        // Check to see if there is a background class on loading
        if ($('.js-navbar-scroll').offset().top > 150) {
            $('.js-navbar-scroll').addClass('navbar-bg-onscroll');
            $('.js-navbar-scroll').addClass('u-box-shadow-lg');
            //nav button
            $('#btn-nav').addClass('btn-white-primary');
            $('#btn-nav').removeClass('btn-blue-ribbon');
            //logo
            $('.navbar-brand').addClass('DYL-white-logo');
            $('.navbar-brand').removeClass('DYL-blue-logo')
        }

        // Check to add a background class on scrolling
        $(window).on('scroll', function () {
            var navbarOffset = $('.js-navbar-scroll').offset().top > 150;
            if (navbarOffset) {
                $('.js-navbar-scroll').addClass('navbar-bg-onscroll');
                $('.js-navbar-scroll').addClass('u-box-shadow-lg');
                //nav button
                $('#btn-nav').addClass('btn-white-primary');
                $('#btn-nav').removeClass('btn-blue-ribbon');
                //logo
                $('.navbar-brand').addClass('DYL-white-logo');
                $('.navbar-brand').removeClass('DYL-blue-logo');

            } else {
                //inital state && when scrolled to top
                if (navLogo == "nav-logo-color-white") {
                    $('.js-navbar-scroll').removeClass('navbar-bg-onscroll');
                    $('.js-navbar-scroll').addClass('navbar-bg-onscroll--fade');
                    $('.js-navbar-scroll').removeClass('u-box-shadow-lg');
                    //nav button
                    $('#btn-nav').removeClass('btn-white-primary');
                    $('#btn-nav').addClass('btn-blue-ribbon');
                    //logo
                    $('.navbar-brand').addClass('DYL-white-logo'); 

                    
                    if ($(".navbar-brand").css("z-index") == "1000") {
                        //Nav logo
                        $('.navbar-brand').removeClass('DYL-blue-logo');
                        $('.navbar-brand').addClass('DYL-white-logo');
                    } 

                    if ($(".navbar-brand").css("z-index") == "999") {
                        //Nav logo
                        $('.navbar-brand').removeClass('DYL-blue-logo');
                        $('.navbar-brand').addClass('DYL-white-logo');
                        
                    } 
                    if($(".btn-responsive-color").css("text-align") == "center"){
                        $('.btn-responsive-color').removeClass('btn-blue-ribbon');
                        $('.btn-responsive-color').addClass('btn-white-primary');
                    }  
                } 

                if(navLogo == "nav-logo-color-blue-white") {
                    $('.js-navbar-scroll').removeClass('navbar-bg-onscroll');
                    $('.js-navbar-scroll').addClass('navbar-bg-onscroll--fade');
                    $('.js-navbar-scroll').removeClass('u-box-shadow-lg');
                    //nav button
                    $('#btn-nav').removeClass('btn-white-primary');
                    $('#btn-nav').addClass('btn-blue-ribbon');
                    //logo
                    $('.navbar-brand').removeClass('DYL-white-logo');
                    $('.navbar-brand').addClass('DYL-blue-logo');

                    if ($(".navbar-brand").css("z-index") == "1000") {
                        //Nav logo
                        $('.navbar-brand').removeClass('DYL-blue-logo');
                        $('.navbar-brand').addClass('DYL-white-logo');
                    } 
                    if ($(".navbar-brand").css("z-index") == "999") {
                        //Nav logo
                        $('.navbar-brand').removeClass('DYL-white-logo');
                        $('.navbar-brand').addClass('DYL-blue-logo');
                    } 
                    if($(".btn-responsive-color").css("text-align") == "center"){
                        $('.btn-responsive-color').removeClass('btn-blue-ribbon');
                        $('.btn-responsive-color').addClass('btn-white-primary');
                    } 
                }

                if(navLogo == "nav-logo-color-white-blue-hold") {
                    $('.js-navbar-scroll').removeClass('navbar-bg-onscroll');
                    $('.js-navbar-scroll').addClass('navbar-bg-onscroll--fade');
                    $('.js-navbar-scroll').removeClass('u-box-shadow-lg');
                    //nav button
                    $('#btn-nav').removeClass('btn-white-primary');
                    $('#btn-nav').addClass('btn-blue-ribbon');
                    //logo
                    $('.navbar-brand').removeClass('DYL-blue-logo');
                    $('.navbar-brand').addClass('DYL-white-logo');
                }
            }
        });
    });

    // Scroll to (Section)
    $(function () {
        $('a[href*=#scroll-to-]:not([href=#scroll-to-])').on('click', function () {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 10
                    }, 1000);
                    return false;
                }
            }
        });
    });

}(jQuery));
